import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AtenderCiudadanoUACComponent } from './atender-ciudadano-UAC.component';

const routes: Routes = [
    
    { path: '', component: AtenderCiudadanoUACComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class AtenderciudadanoUACRouting { }